import { render } from "./ContactForm.vue?vue&type=template&id=0ef686a0"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/isaias/Developer/Trayectics/Trayectics-Questions/trayectics_questions/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__